import { GROUP_IMG_PRE_PATH, LINK_PRE_PATH } from './index';

export const headBg = GROUP_IMG_PRE_PATH + 'pc/4fdd9282c02216accb60afa3d0ad2d2e644bd20f199aa4ec9749d9c42fdcbea0.jpg';
export const headBgM = GROUP_IMG_PRE_PATH + 'pc/d6a0395823bf769c26aeab0190a46be9b68f9d9f77766bb1e1f09f275ee24363.jpg';
export const frameSrc = GROUP_IMG_PRE_PATH + 'pc/94395d14b445c795f713fcd189602942a285f617458227be8b4b68a1b4fbb4e3.jpg';
export const frameSrcM = GROUP_IMG_PRE_PATH + 'pc/07f86029e714324bb1a8724df2fe03637b2f9e6e07baa0d304711460ab32dfc3.jpg';

export const challenge = [
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/42b72198cbda7c96a29bb5a4f8b7fbf3d550cb8773f663cc6d5b786ef7cb9493.png',
    title: '企业规模大，总部及分支联动难',
    desc: '在企业集团规模不断扩张的进程中，传统视频会议难满足总部与分支机构间紧密联动需求',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/e38d71a49d7e33b39c46a62222d9f7c1893e8da3919f1a026e49d07937c1fb92.png',
    title: '层级多协作难，降本增效成瓶颈',
    desc: '企业集团层级多，跨部门沟通难，亟需提高协作效率，降低如差旅经费等各项成本',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/81cddc12137395fde9aec162fc472b8546daeac8f728c74ae06a1c1ef126cc3c.png',
    title: '业务需求多样化，场景应用难深入',
    desc: '除日常会议、企业培训外，需深入业务流程扩展更多场景应用，探寻高效协同新方式',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/ddc2cd8c580abbe679173a334376bf1f2aa19ac05229737cbca11a160107c0ae.png',
    title: '旧系统设备不一，运维难成本高',
    desc: '兼顾设备利旧基础上，需解决原有视频会议系统陈旧或操作复杂等问题，减轻运维成本',
  },
];
export const frame = [
  {
    title: '高效组织会议',
    icon: GROUP_IMG_PRE_PATH + 'pc/1a9612a6f5ffcbae76fed63781c594a66e98453d82568114f0b908860b49cba9.png',
  },
  {
    title: '降低协作成本',
    icon: GROUP_IMG_PRE_PATH + 'pc/fa946d09390c3fcd3af2352b6b5bcd62b7bf84a5fbfa8bb4630e69090dcb790d.png',
  },
  {
    title: '嵌入业务场景',
    icon: GROUP_IMG_PRE_PATH + 'pc/755d6bc43121cef1bdeb80dbbab62bc8755abd23da0beac56f5c2f3e14c7193b.png',
  },
  {
    title: '设备兼容利旧',
    icon: GROUP_IMG_PRE_PATH + 'pc/1efd342155c574e9a0f7fa8c701863d275ed69f43b8f446402cf3ab34abc2e39.png',
  },
];
export const advantage = [
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/639e7221ee58ef1e94d0afd1196f9cb72749b9587fbd06811784cd9bd472744c.png',
    title: '助降本增效',
    desc: '云视频方案应用成本远低于传统硬件视频会议，方案部署简单，使用便捷高效，企业运维成本低',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/68979ad392e91c378cf24b24c95fffd44bfc3d080c65373c0a037be1314f36c8.png',
    title: '超融合应用',
    desc: '视频会议、监控、直播、录播、数据、语音融合互通，统一媒体接入能力，软件定义架构，万方接入',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/b0af140cad95de7891bdab6214a51adc0bd6ffcf8da3093cde0e8f83cf9abcca.png',
    title: '强稳定可靠',
    desc: '运营级集群架构，MCU资源池，多活热备，7年不间断稳定运营，打造了超大规模的云视频服务平台，无单点故障',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/0c61ed2215d72793a025f868960559d79e32f8736569b0be67c1f23132891983.png',
    title: '超高清体验',
    desc: '全自研底层技术，具备完全自主核心知识产权，“云+端”国产化软硬件方案有效保障1080P/4K超高清体验',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
    title: '全场景覆盖',
    desc: '覆盖企业大中小会议室、桌面、移动端等各类型终端，可灵活接入内外网、企业专网、互联网、4G/5G等多网络环境，随时随地开展业务协同',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/72abb4a6fb3e84800a01164b1497efa20ae197c93d1213928156bb947035a3b0.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，深度集成并融合企业业务流程，打造企业集团云视频应用新范式',
  },
];
export const scene = [
  {
    title: '行政会议',
    desc: '构建安全、保密、流畅的线上商务会议环境，满足企业全员大会及各层级行政会议召开需求',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/fd13e74ca815e81c4f669c5ae4d52d8bbe198d015062ca4ae03700771938f9ef.jpg',
  },
  {
    title: '协同办公',
    desc: '实时视频互动，屏幕、文档、音视频文件可即时共享，支持手机分享及电子白板多人互动',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/824435637ea34ba81566dc93f1a916af9cc25945fcd0313dd6d9e7ac986f17b6.jpg',
  },
  {
    title: '企业培训',
    desc: '构建培训平台，实现培训前排课、通知、签到；培训中实时互动、直播；培训后回放分享、答题等',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/82d2abbda8f56f32410463e5b8548646199bb5caf9507af544dec834e5d9111e.jpg',
  },
  {
    title: '远程招聘',
    desc: '将现场招聘优化为线上面试，突破传统招聘方式在时间、地域上的限制，提高招聘效率',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/39b3f62f5789371fa63c23573ab460b4787a78741d7af6d4f94cfb2a491fd0ac.jpg',
  },
  {
    title: '商务洽谈',
    desc: '满足大规模4K互动视频商务洽谈需求，可实现异地多方音频、视频、数据共享等远程协作',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/a1bfd6b3ddacfea3221173030e003da2e477d2f0468173b8c024e9017ee5f878.jpg',
  },
  {
    title: '活动直播',
    desc: '发布会、年会等可通过直播进行大规模推广，为产品销售、品牌知名度提升提供专业服务',
    pcUrl: GROUP_IMG_PRE_PATH + 'pc/bb6cd6d6ab14c43669b07ff8f9c8153232afade7e62093e5cc3452faa4929c6d.jpg',
  },
];
export const caseList = [
  [
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/8162b88213ed2b59d8b893d8d8f7eea465041b5cacd26626f77335e73abbbcad.png',
      title: '中国海洋石油集团有限公司',
      desc: '中国海油是国务院批准成立的特大型国有企业，是中国最大的海上油气生产运营商，业务遍及40多个国家和地区。为保证生产生活的高效推进，中国海油应用小鱼易连云视频，建设了企业会议系统，通过打造融合通信云平台，实现应急指挥、会议会商、远程办公、智慧党建等创新场景应用，“大规模、高效率、全贯通”的协作新模式，为未来发展提供了强劲引擎。',
      link: LINK_PRE_PATH + '1083',
    },
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/c90faf2240c4b2143da61503fd6fbe787ec48d74bcdca43b2ad36f9a2742b897.png',
      title: '中国长江三峡集团有限公司',
      desc: '三峡集团是全球最大的水电开发运营企业和中国最大的清洁能源集团，业务遍布40多个国家和地区，员工数量达3万余人。携手小鱼易连，三峡集团建设全球融合云视频系统，可支撑近万个部门的跨国、跨地域互动视频连线，实现业务协作大范围覆盖。云化部署能力、超高清视频会议、全球互联网融合接入、中台支撑能力等系统属性，让集团的全球业务互联更加轻松与便捷。',
      link: LINK_PRE_PATH + '1020',
    },
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/99622dfa84accd287698e56b1dba450e447d62b5e9f8af3a1cb43e26bdebdcdb.png',
      title: '中国电子信息产业集团有限公司',
      desc: '中国电子信息产业集团有限公司是中央直接管理的国有重要骨干企业。作为网信产业国家队，中国电子积极创新探索和构建国产安全的数字底座，依托PKS生态体系，联合小鱼易连打造数字CEC视频能力平台，具备云协作、云视讯、云融合、云直播、云录播、云监控、云AI等服务功能，令全集团各公司、部门等18余万员工，实现了大范围、大规模的业务协同和更多场景的可视化应用。',
      link: LINK_PRE_PATH + '1075',
    },
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/621ec874412b115eeb8f2140fe3fb6a77dd04da9a2e2263ee01a36c70f80dd4c.png',
      title: '中国节能环保集团有限公司',
      desc: '中国节能与小鱼易连共同打造中国节能云视频系统，集统一身份认证系统、主数据系统、数据交换平台、内网门户和移动门户于一体，并能与原有硬件设备构建的视频会议系统进行融合应用。在3个月的试运行期间，中国节能通过云视频召开各种类型会议4500余次，累计会议时长超过1500000分钟。项目建成后，小鱼易连云视频已经成为中国节能召开各种类型会议的核心平台，为中国节能在运营、管理、办公等各业务场景提供了重要保障，有效提高了内外部沟通效率。',
      link: LINK_PRE_PATH + '917',
    },
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/79fc4a746c46b532c2e48739dc301b3a39b6d8c579d7cb4b9dca3611eba8ba51.png',
      title: '中国中钢集团有限公司',
      desc: '中国中钢集团有限公司是集矿产资源、工程装备、科技新材等业务为一体的大型跨国企业集团。中钢集团原有会议系统建设超过十年，难以满足现有业务发展需求。在集团不断追求数字化发展的进程中，经过充分的市场调研和评估，携手小鱼易连，应用高效便捷的云视频进行升级。系统不仅兼容已有会议设备，同时满足海外客户顺畅接入、全球员工远程办公协作的需求，并支持移动应用，让集团的视讯协作更加高效。',
      link: LINK_PRE_PATH + 'b6c5d7',
    },
    {
      logo: GROUP_IMG_PRE_PATH + 'pc/b03174c14f7a92eca201523c6014529198379109bcb4e88a906d31e271cd9a34.png',
      title: '北森云计算有限公司',
      desc: '北森云计算有限公司基于小鱼易连云视频搭建了远程办公系统。经过多年的稳定运营，云视频应用已逐渐深入到北森的研发乃至日常办公流程中，支撑了北京、成都双总部及全国十几家分公司的远程沟通、异地协作，保障多地研发中心及各部门进行高效联动。此外，云视频还满足企业培训、远程面试、视频客服、远程观摩、商务洽谈等各业务场景，助力北森精细化运作，降本增效，实现数字化转型。',
      link: LINK_PRE_PATH + '941',
    },
  ],
];
